import ActionSelector from '../../components/ActionSelector'
import { useModuleAction } from '../../hooks/useModuleAction'
import { type ChainAction } from './constants'
import DeleteChainForm from './DeleteChainForm'
import InsertChainForm from './InsertChainForm'

export default function ChainModule() {
  const { selectedAction, selectAction, isValidAction } =
    useModuleAction('chain')

  const formByAction = {
    insert: InsertChainForm,
    delete: DeleteChainForm,
  } satisfies Record<ChainAction, React.ComponentType>

  const Form = selectedAction ? formByAction[selectedAction] : null

  if (!isValidAction) {
    return <ActionSelector module='chain' onSelectAction={selectAction} />
  }

  return <div className='space-y-4'>{Form && <Form />}</div>
}
